<template>
  <xr-create :loading="loading" :title="title" @close="close" @save="saveClick">
    <create-sections title="基本信息">
      <el-form
        ref="crmForm"
        :model="fieldForm"
        :rules="fieldRules"
        :validate-on-rule-change="false"
        class="wk-form"
        label-position="top"
      >
        <wk-form-items
          v-for="(children, index) in fieldList"
          :key="index"
          :field-from="fieldForm"
          :field-list="children"
          @change="formChange"
        />
        <div v-if="autoFill" class=" w100 fx-col-start al-start pd-t-12 pd-horizontal-22">
          <div class="pd-b-8">自动识别</div>
          <el-input
            v-model="autoFillValue"
            :rows="3"
            type="textarea"
            @input="_autoFill"
            placeholder="自动识别框，粘贴内容例如: wechat_number 18883880447 抖音 重庆"
          ></el-input>
        </div>
      </el-form>
    </create-sections>
  </xr-create>
</template>

<script>
import { filedGetFieldAPI } from "@/api/crm/common";
import { crmLeadsSaveAPI } from "@/api/crm/leads";

import XrCreate from "@/components/XrCreate";
import CreateSections from "@/components/CreateSections";
import WkFormItems from "@/components/NewCom/WkForm/WkFormItems";

import CustomFieldsMixin from "@/mixins/CustomFields";
import { isEmpty } from "@/utils/types";
import utils from "@/utils/utils.js";
export default {
  // 新建编辑
  name: "LeadsCreate",

  components: {
    XrCreate,
    CreateSections,
    WkFormItems,
  },

  mixins: [CustomFieldsMixin],

  props: {
    phone: String,
    action: {
      type: Object,
      default: () => {
        return {
          type: "save",
          id: "",
          data: {},
        };
      },
    },
  },

  data() {
    return {
      autoFillValue: "",
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},
    };
  },

  computed: {
    title() {
      return this.action.type === "update" ? "编辑线索" : "新建线索";
    },
    autoFill() {
      return Boolean(
        this.fieldList.find(outer => {
          return outer.find(item => {
            return (
              item.form_type == "mobile" ||
              (item.form_type == "select" && item.field == "source") ||
              utils.phoneFillFieldNames.filter(str => {
                return item.name.includes(str);
              }, []).length
            );
          });
        })
      );
    },
  },

  watch: {},

  created() {
    this.getField();
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    _autoFill: utils.autoFill,
    /**
     * 获取数据
     */
    getField() {
      this.loading = true;
      const params = {
        types: "crm_leads",
        module: "crm",
        controller: "leads",
        action: this.action.type,
        format: 2,
      };

      if (this.action.type == "update") {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params)
        .then(res => {
          const list = res.data || [];
          if (!isEmpty(this.phone)) {
            list.forEach(item => {
              if (item.form_type === "mobile") {
                item.default_value = this.phone;
              }
            });
          }
          const assistIds = this.getFormAssistIds(list);
          const baseFields = [];

          const fieldList = [];
          const fieldRules = {};
          const fieldForm = {};
          list.forEach(children => {
            const fields = [];
            children.forEach(item => {
              const temp = this.getFormItemDefaultProperty(item);
              temp.show = !assistIds.includes(item.formAssistId);

              const canEdit = this.getItemIsCanEdit(item, this.action.type);
              // 是否能编辑权限
              if (temp.show && canEdit) {
                fieldRules[temp.field] = this.getRules(item);
              }

              // 是否可编辑
              temp.disabled = !canEdit;

              // 特殊字段允许多选
              this.getItemRadio(item, temp);

              // 获取默认值
              if (temp.show) {
                fieldForm[temp.field] = this.getItemValue(item, this.action.data, this.action.type);
              }
              fields.push(temp);
              baseFields.push(item);
            });
            fieldList.push(fields);
          });

          this.baseFields = baseFields;
          this.fieldList = fieldList;
          this.fieldForm = fieldForm;
          this.fieldRules = fieldRules;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 保存
     */
    saveClick() {
      this.loading = true;
      const crmForm = this.$refs.crmForm;
      crmForm.validate(valid => {
        if (valid) {
          const params = this.getSubmiteParams(this.baseFields, this.fieldForm);
          if (this.action.type === "update") {
            params.id = this.action.id;
          }
          console.log(params);
          this.submiteParams(params);
        } else {
          this.loading = false;
          // 提示第一个error
          this.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },

    /**
     * 提交上传
     */
    submiteParams(params) {
      if (this.action.type == "update") {
        params.action_id = this.action.id;
        // params.entity.batchId = this.action.batchId
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && Object.keys(this.action.relativeData).length) {
        params = { ...params, ...this.action.relativeData };
      }
      crmLeadsSaveAPI(params)
        .then(res => {
          this.loading = false;
          this.$message.success(this.action.type == "update" ? "编辑成功" : "添加成功");

          this.close();

          // 保存成功
          this.$emit("save-success", {
            type: "leads",
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 验证唯一
     */
    UniquePromise({ field, value }) {
      return this.getUniquePromise(field, value, this.action);
    },

    /**
     * change
     */
    formChange(field, index, value, valueList) {
      if (["select", "checkbox"].includes(field.form_type) && field.remark === "options_type" && field.optionsData) {
        const { fieldForm, fieldRules } = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm);
        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },

    /**
     * 地址change
     */
    otherChange(data, field) {
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },

    /**
     * 关闭
     */
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
